import { Axios } from "axios";
import { Game } from "./Game";
import { rsort } from "semver";
import { Constants } from "@/constant/Constants";
import { GameConfigType } from "@/types";

export async function loadGameVersions(game: Game, http: Axios): Promise<Array<string>> {
  const { id, buildPrefix } = game;
  const response = await http
    .get(
      `${Constants.OCTOPUS_API_URL}/game-builds?gameName=${id}&buildPrefix=${buildPrefix}`
    );

  const { data } = response;
  const versions: string[] = rsort(data[Constants.VERSIONS] ?? []);
  return versions;
}

export async function loadGameConfigs(game: Game, http: Axios): Promise<Array<GameConfigType>> {
  let configs: GameConfigType[] = [];

  if (
    game.getConfigs().length < 1 &&
    game.configPath
  ) {
    try {
      const response = await http
        .get(
          `${Constants.AWS_URL}/frontend-lobby/data/${game.configPath}` +
          generateNoCacheString()
        );

      configs = response.data[Constants.CONFIGS];
    } catch (error) {
      const response = await http
        .get(
          `../data/${game.configPath}` + generateNoCacheString()
        );

      configs = response.data[Constants.CONFIGS];
    }
  }

  if(game.gameIdPrefix){
    configs.forEach((configData) => {
      configData.id = `${game.gameIdPrefix}-${configData.id}`;
    });
  }

  return configs;
}

export function generateNoCacheString(): string {
  return "?nocache=" + (new Date()).getTime();
}

export function localStorageGetOrDefault<T>(id: string, defaultValue: T): T {
  try {
    const localStorageValue = localStorage.getItem(id);
    if (localStorageValue && localStorageValue !== "") {
      return <T>JSON.parse(localStorageValue);
    }
    return defaultValue;
  } catch {
    return defaultValue;
  }
}

export function localStorageSet<T>(key: string, value: T): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
}
